



































































































































import { Component, Prop, Watch } from "vue-property-decorator";
import CardModalTtd from "@/components/modal/CardModalTtd.vue";
import BaseSuketCard from "@/pages/PemeriksaanPage/SuratKeteranganTabPage/BaseSuketCard.vue";
import UnitRuangPicker from "@/components/common/UnitRuangPicker.vue";
import CommonSuket, { EnSuketCategory } from "@/services/CommonSuket";
import BaseSuketTabPage from "@/pages/PemeriksaanPage/SuratKeteranganTabPage/BaseSuketTabPage";
import StoreSuketTindakanUmum from "@/store/modules/SuketTindakanUmum";
import { userModule } from "@/store/modules/user";
import { appModule } from "@/store/modules/app";
import { storePasien } from "@/store/modules/pasien";
import pdf from "vue-pdf";

@Component({
  components: {
    CardModalTtd,
    BaseSuketCard,
    UnitRuangPicker,
    pdf
  }
})
export default class SuketTindakanUmumTabPage extends BaseSuketTabPage {
  @Prop() declare readonly register: string | number;

  // Tersedia di semua poli ralan & ranap.
  allowedUnit = ["*"];
  suketSvc = new CommonSuket(EnSuketCategory.TindakanUmum);
  suketStore = StoreSuketTindakanUmum;

  register_id = this.register;
  pasien_rm = this.pasien.rm;
  unit_id = this.user.unit_id;
  surat_date = new Date();
  signee_user_id = this.user.id;
  creator_user_id = this.user.id;

  bangsal: string | null = null;
  tindakan: Array<{ tanggal: string | null; tindakan: string | null }> = [];

  saving = false;
  loadedRatio = 0;

  get pasien() {
    return storePasien.identitasPasien;
  }

  get user() {
    return userModule.user;
  }

  get pdfUrl() {
    return this.dataSuket
      ? this.getSuketPdfUrl(EnSuketCategory.TindakanUmum, this.dataSuket.id)
      : null;
  }

  get input() {
    return {
      register_id: this.register_id,
      pasien_rm: this.pasien_rm,
      unit_id: this.unit_id,
      content: {
        bangsal: this.bangsal,
        tindakan: this.tindakan
      },
      surat_date: this.surat_date,
      signee_user_id: this.signee_user_id,
      creator_user_id: this.creator_user_id
    };
  }

  get canSign() {
    return this.user.id == this.signee_user_id;
  }

  mounted() {
    this.hydrate(this.dataSuket);
  }

  hydrate(d: any) {
    this.register_id = d?.register_id || this.register;
    this.pasien_rm = d?.pasien_rm || this.pasien.rm;
    this.unit_id = d?.unit_id || this.user.unit_id;
    this.surat_date = d?.surat_date || new Date();
    this.signee_user_id = d?.signee_user_id || this.user.id;
    this.creator_user_id = d?.creator_user_id || this.user.id;

    const c = d?.content;
    if (c) {
      this.bangsal = c.bangsal ?? null;
      this.tindakan = Array.isArray(c.tindakan) ? c.tindakan : [];
    }
  }

  @Watch("dataSuket")
  changeDataSuket(val: any) {
    this.hydrate(val);
  }

  addTindakan() {
    this.tindakan.push({ tanggal: null, tindakan: null });
  }

  removeTindakan(i: number) {
    this.tindakan.splice(i, 1);
  }

  save() {
    if (this.saving) return;
    if (!this.tindakan.length || !this.tindakan.some(t => (t.tindakan || "").trim())) {
      appModule.sendErrorAlert("Minimal satu tindakan wajib diisi");
      return;
    }

    this.saving = true;
    const action = this.dataSuket
      ? this.suketSvc.update(this.dataSuket.id, this.input)
      : this.suketSvc.create(this.input);

    action
      .then(() => {
        if (this.canSign) {
          this.showSignatureModal();
        }
        appModule.NoticeDelay("Berhasil Simpan");
        this.closeInput();
        StoreSuketTindakanUmum.getSuketByRegister(this.register);
      })
      .finally(() => {
        this.saving = false;
      });
  }

  remove() {
    if (!this.dataSuket) return;
    this.suketSvc.destroy(this.dataSuket.id).then(() => {
      appModule.NoticeDelay("Berhasil Hapus Surat Keterangan");
      StoreSuketTindakanUmum.getSuketByRegister(this.register);
    });
  }
}
